(function(){
  const FORM_SELECTOR = 'form.g-container[data-id="88191"]';
  const MAX_WAIT_MS   = 10_000;
  const POLL_INTERVAL = 200;
  let attached = false;

  // 1️⃣ Create & show the branded modal
  function showModal(number) {
    // Overlay
    const overlay = document.createElement('div');
    Object.assign(overlay.style, {
      position:       'fixed',
      top:            0,
      left:           0,
      width:          '100vw',
      height:         '100vh',
      background:     'rgba(0,0,0,0.75)',
      display:        'flex',
      alignItems:     'center',
      justifyContent: 'center',
      zIndex:         99999,
    });

    // Modal box
    const box = document.createElement('div');
    Object.assign(box.style, {
      background:    '#6A167E',
      color:         '#ffffff',
      padding:       '2rem',
      borderRadius:  '8px',
      textAlign:     'center',
      maxWidth:      '90%',
      width:         '300px',
      boxSizing:     'border-box',
      boxShadow:     '0 4px 12px rgba(0,0,0,0.3)'
    });

    // Title
    const title = document.createElement('h2');
    title.textContent = 'Your number is:';
    Object.assign(title.style, {
      margin:       '0 0 1rem',
      fontSize:     '1.25rem',
      fontWeight:   'normal',
      lineHeight:   '1.4'
    });

    // Number display
    const numEl = document.createElement('div');
    numEl.textContent = number;
    Object.assign(numEl.style, {
      fontSize:   '3rem',
      fontWeight: 'bold',
      margin:     '0 0 1.5rem'
    });

    // Close button
    const closeBtn = document.createElement('button');
    closeBtn.textContent = 'Close';
    Object.assign(closeBtn.style, {
      background:     '#ffffff',
      color:          '#6A167E',
      border:         'none',
      padding:        '0.5rem 1rem',
      borderRadius:   '4px',
      cursor:         'pointer',
      fontSize:       '1rem',
      fontWeight:     'bold'
    });
    closeBtn.addEventListener('click', () => {
      document.body.removeChild(overlay);
    });

    box.append(title, numEl, closeBtn);
    overlay.appendChild(box);
    document.body.appendChild(overlay);
  }

  // 2️⃣ Handle form submission & only validate email
  function handleSubmit(e) {
    const emailEl = document.getElementById('88191-email');
    const email = emailEl?.value.trim() || '';
    const emailValid = /\S+@\S+\.\S+/.test(email);

    if (emailValid) {
      console.log('✅ Email valid, submit fired:', email);
      // Generate random 1–7
      const number = Math.floor(Math.random() * 7) + 1;
      showModal(number);
      // Let the form continue its normal submission (e.g. AJAX)
    } else {
      console.log('❌ Invalid email, blocking submit:', email);
      e.preventDefault(); // block submission if email is invalid
      emailEl.classList.add('input-error'); // optional: highlight the field
    }
  }

  // 3️⃣ Poll until the form exists, then attach once
  const start = Date.now();
  const poller = setInterval(() => {
    if (attached) return;
    const form = document.querySelector(FORM_SELECTOR);
    if (form) {
      form.addEventListener('submit', handleSubmit);
      attached = true;
      console.log('[form-listener] attached to submit event');
      clearInterval(poller);
    } else if (Date.now() - start > MAX_WAIT_MS) {
      console.warn('[form-listener] giving up—form never appeared');
      clearInterval(poller);
    }
  }, POLL_INTERVAL);
})();
